const base = 0;
const above = 1;
const below = -1;
const background = base;
const container = base;
const text = base;
const image = base;
const badge = base;
const defaultRedemption = above + base;
const selectedRedemption = above + defaultRedemption;
const input = above + text;
const listItem = above + text;
const selectDropdown = above + input;
const backdrop = container + 10;
const cardWrapper = below + backdrop;
const card = below + cardWrapper;
const modalContent = above + backdrop;
const tooltip = above + backdrop;
const flyoutBackground = above + backdrop + 10;
const flyoutContent = above + flyoutBackground;
const nav = below + backdrop;
export const zIndex = {
    background,
    container,
    text,
    image,
    badge,
    input,
    listItem,
    selectDropdown,
    backdrop,
    flyoutBackground,
    modalContent,
    flyoutContent,
    tooltip,
    cardWrapper,
    card,
    defaultRedemption,
    selectedRedemption,
    nav,
};
//# sourceMappingURL=zIndex.js.map